import { useEffect, useMemo } from "react";

const AdBanner = (props) => {
    const googletag = window.googletag || (window.googletag = { cmd: [] });

    const id = useMemo(() => `${props.id}`, []);
    const createScope = (action) => action && action();


    useEffect(() => {
        const slot = GPTAdsManager.createSlot(props.path, 400, 600, id);
        slot.display();
        // slot.refresh(); // forces Ad reloading
        return () => {
            slot.destroy();
        };
    }, []);

    const GPTAdsManager = createScope(() => {
        let initialized = false;
        const initializeAds = (initialLoading = false, singleRequest = true) => {

            if (initialized) {
                return;
            }

            initialized = true;
            googletag.cmd.push(() => {
                const pubads = googletag.pubads();

                if (!initialLoading) {
                    pubads.disableInitialLoad();
                }
                if (singleRequest) {
                    pubads.enableSingleRequest();
                }
                googletag.enableServices();
            });
        };
        const createSlot = (adPath, adWidth, adHeight, elementId) => {
            initializeAds(); // only if not initialized yet
            let slot = null;
            googletag.cmd.push(() => {
                const size = adWidth & adHeight ? [adWidth, adHeight] : ['fluid'];
                const tmp = googletag.defineSlot(adPath, size, elementId);
                if (tmp) {
                    slot = tmp;
                    tmp.addService(googletag.pubads());
                }
            });
            const display = () => {
                if (slot) {
                    googletag.cmd.push(() => {
                        const pubads = googletag.pubads();
                        pubads.refresh([slot]);
                    });
                }
            };
            const refresh = () => {
                if (slot) {
                    googletag.cmd.push(() => {
                        const pubads = googletag.pubads();
                        pubads.refresh([slot]);
                    });
                }
            };
            const destroy = () => {
                if (slot) {
                    const tmp = slot;
                    googletag.cmd.push(() => {
                        const pubads = googletag.pubads();
                        googletag.destroySlots([tmp]);
                    });
                    slot = null;
                }
            };
            return { display, refresh, destroy };
        }
        return { initializeAds, createSlot };
    });




    return (
        <div id={id} />
    );


}



export default AdBanner;